import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InformedConsentQuestionAddEditComponent } from './informed-consent-question-add-edit/informed-consent-question-add-edit.component';

const routes: Routes = [
  {
    path: 'add',
    component: InformedConsentQuestionAddEditComponent,
  },
  {
    path: 'edit/:questionId',
    component: InformedConsentQuestionAddEditComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class InformedConsentQuestionRoutingModule {}
